const getters = {
    gpsdevices: (state) => state.gpsdevices,
    gpsdeviceId: (state) => state.gpsdeviceId,
    loading: state => state.loading
};

export default getters;